export default function autoEvent() {
  const widgetName = 'autoEvent';
  const widgetOpts = autoEventOpts;

  const $widget = $(`#${widgetName}`);

  $widget.find('.btn-container').before(`<div class="multiFeatureContent"></div>`);

  $widget.MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: false,
    maxItemsVisible: 4,
    isResponsive: false,
    allEventsLink: false,
    link: 'all',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      const widgetData = data;

      if (widgetData.length == 0) {
        $(`.autofeed-buttons-container`).addClass('no-events');
        $widget.remove();
      } else {
        createCustomEvents(widgetName, widgetData);
      }
    },
  });
}

function createCustomEvents(widgetName, data) {
  $('#multiScheduleFeature').prepend();

  $(`#${widgetName} .featureItem`).each(function (i) {
    const { Date: widgetDate, Name: widgetName, URL: widgetURL } = data[i];

    let fixedDate = widgetDate.split('-');
    let dayStart;
    let monthStart;
    let dayEnd;
    let monthEnd;
    let dateLayout;

    switch (fixedDate.length) {
      case 1:
        dayStart = formatDate(fixedDate, 0, 0, 1);
        monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
        dateLayout = buildEventDateLayout(monthStart, dayStart);
        break;

      case 2:
        monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
        dayStart = formatDate(fixedDate, 0, 0, 1);
        monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
        dayEnd = formatDate(fixedDate, 1, 0, 1);
        dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
        break;

      default:
        break;
    }

    $(this).empty();
    $(this).append(buildEventInfoLayout(widgetName));

    if (widgetURL == '') {
      $(this).removeAttr('href');
      $(this).addClass('void');
    }

    $(this).append(dateLayout);
    if (widgetURL != '') {
      $(this).attr('href', widgetURL);
    }
  });
}

function buildEventInfoLayout(title) {
  let infoLayout = `  
    <div class="event-info">
      <span class="event-name">${title}</span>
    </div>`;

  return infoLayout;
}

function formatDate(date, slot1, slot2, slot3) {
  let splittedDate = date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
  return splittedDate;
}

function buildEventDateLayout(
  eventStartMonth,
  eventStartDay,
  eventEndMonth = null,
  eventEndDay = null,
) {
  let dateLayout;
  if (eventEndMonth === null || eventEndDay === null) {
    dateLayout = `
            <div class="event-date ">
                <span class="month">${eventStartMonth}</span>
                <span class="day">${eventStartDay}</span>
            </div>`;
  } else if (eventStartMonth == eventEndMonth) {
    dateLayout = `
            <div class="event-date double-date">
                <span class="month">${eventStartMonth}</span>
                <span class="day">${eventStartDay}<span class="divider">-</span>${eventEndDay}</span>
            </div>`;
  } else {
    dateLayout = `
            <div class="event-date date-range">
                <div class="combo-date">
                    <span class="month">${eventStartMonth}</span>
                    <span class="day">${eventStartDay}</span>
                    </div>
                    
                <span class="divider-month">-</span>
  
                <div class="combo-date">
                    <span class="month">${eventEndMonth}</span>
                    <span class="day">${eventEndDay}</span>
                </div>
            </div>`;
  }
  return dateLayout;
}
